import i18next from 'i18next';
import Swal from 'sweetalert2';

async function cancelarAlert({ opcoes = {}, confirmar = () => {}, cancelar = () => {}, aceitarTexto, recusarTexto }) {
  const locale = await i18next.getResourceBundle(i18next.language, 'services/alerts');

  const result = await Swal.fire({
    reverseButtons: true,
    title: locale.cancelarAlert.titulo,
    text: locale.cancelarAlert.mensagem,
    icon: 'warning',
    showCancelButton: true,
    cancelButtonColor: '#d33',
    confirmButtonColor: '#3085d6',
    confirmButtonText: aceitarTexto ? aceitarTexto : locale.acoes.confirmar,
    cancelButtonText: recusarTexto ? recusarTexto : locale.acoes.cancelar,
    ...opcoes,
  });
  if (result.value) {
    confirmar(result);
  } else {
    cancelar(result);
  }
}

export default cancelarAlert;
